import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type MigrationRequestInPendingStateErrorOptions = {
  migrationRequest: ObjectId;
};

export class MigrationRequestInPendingStateError extends FleekError<MigrationRequestInPendingStateErrorOptions> {
  public name = 'MigrationRequestInPendingStateError';

  toString = () => 'Migration request is in pending state. Please wait and try action again later.';
}
